import React from "react";
import ButtonPlus from "../../Assets/Images/plus.svg";


function ButtonAdd() {
  return <img src={ButtonPlus} alt="" />;
}

export default ButtonAdd;
